import { FIELD_PATH_BUSINESS_NAME, FIELD_PATH_HOURS, FIELD_PATH_PRIMARY_EMAIL, FIELD_PATH_PRIMARY_PHONE, FIELD_PATH_SERVICE_AREA_NAME, FIELD_PATH_SERVICE_NAME, } from "../contracts/business-graph-contradiction.js";
/** Collapse whitespace; trim. */
export function normalizeWhitespace(value) {
    return value.trim().replace(/\s+/g, " ");
}
/**
 * Phone equality: digits only; strip a single leading US country code `1` when 11 digits.
 * Formatting differences (parens, dashes, spaces) do not create contradictions.
 */
export function normalizePhoneForComparison(value) {
    const digits = value.replace(/\D/g, "");
    if (digits.length === 11 && digits.startsWith("1")) {
        return digits.slice(1);
    }
    return digits;
}
/** Email: trim + lowercase (case is not semantic for contact email). */
export function normalizeEmailForComparison(value) {
    return normalizeWhitespace(value).toLowerCase();
}
/** Business / service / area names: trim, collapse space, case-fold. */
export function normalizeTextNameForComparison(value) {
    return normalizeWhitespace(value).toLowerCase();
}
/**
 * Hours value form: `open|close` with HH:MM zero-padded when numeric.
 * Accepts `09:00`, `9:00`, `9:00 AM`-style stripped to 24h when possible via digit clock only.
 */
export function normalizeHoursSlotForComparison(open, close) {
    const normPart = (part) => {
        const trimmed = normalizeWhitespace(part).toUpperCase();
        const match = trimmed.match(/^(\d{1,2}):(\d{2})(?:\s*(AM|PM))?$/);
        if (!match) {
            return trimmed.toLowerCase();
        }
        let hour = Number(match[1]);
        const minute = match[2];
        const meridiem = match[3];
        if (meridiem === "PM" && hour < 12)
            hour += 12;
        if (meridiem === "AM" && hour === 12)
            hour = 0;
        return `${String(hour).padStart(2, "0")}:${minute}`;
    };
    const closePart = close === undefined || close.trim() === "" ? "" : normPart(close);
    return `${normPart(open)}|${closePart}`;
}
export function normalizeComparableFactValue(fieldPath, value) {
    switch (fieldPath) {
        case FIELD_PATH_PRIMARY_PHONE:
            return normalizePhoneForComparison(value);
        case FIELD_PATH_PRIMARY_EMAIL:
            return normalizeEmailForComparison(value);
        case FIELD_PATH_BUSINESS_NAME:
        case FIELD_PATH_SERVICE_NAME:
        case FIELD_PATH_SERVICE_AREA_NAME:
            return normalizeTextNameForComparison(value);
        case FIELD_PATH_HOURS:
            // Value already expected as open|close from extractor.
            {
                const [open = "", close] = value.split("|");
                return normalizeHoursSlotForComparison(open, close);
            }
        default:
            return normalizeWhitespace(value).toLowerCase();
    }
}
//# sourceMappingURL=normalize-comparable-fact-value.js.map